import AdminLayout from '../components/Layouts/AdminLayout'
import HeaderContainer from '../containers/Header/Header.container'
import SidebarContainer from '../containers/Sidebar/Sidebar.container'
import SupportHelpContainer from '../containers/Support/SupportHelp.container'
import { PageStack } from '../components/Layouts/PagePanel'

const HelpPage = () => {
  return (
    <AdminLayout
      header={<HeaderContainer />}
      sidebar={<SidebarContainer />}
      title="Contacto"
      description="Cuéntanos qué necesitas: soporte, un comentario o una consulta comercial."
    >
      <PageStack>
        <SupportHelpContainer />
      </PageStack>
    </AdminLayout>
  )
}

export default HelpPage
